import React from 'react'
import cx from 'classnames'

import { CompanyInitialLetter } from './icons/CompanyInitialLetter'
import { CompanyNameLetters } from './icons/CompanyNameLetters'
import { MainNavigationLogoProps } from './interfaces'

import cm from './MainNavigationLogo.module.css'

export const MainNavigationLogo = ({ isExpanded }: MainNavigationLogoProps) => {
  return (
    <div className={cx(cm.logoContainer, { [cm.logoContainer_expanded]: isExpanded })}>
      <CompanyInitialLetter className={cm.capitalLetter} />
      <CompanyNameLetters className={cm.letters} />
    </div>
  )
}
